import * as React from "react";
import { useShop } from "../shopService";
import "./LoadingTriangle.css";

export const LoadingTriangle = () => {
  const shopId = process.env.REACT_APP_SHOP_ID || '0';

  const {
    name,
    logoUrl,
    storeUrl,
    color,
    lightColor,
    error
  } = useShop(shopId);

  const background = {'--color': color} as React.CSSProperties;

  return (
  <div className="lds-roller" style={background}>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
)};

export const LoadingTrianglePage = ({ withText }: { withText?: string }) => {
  const shopId = process.env.REACT_APP_SHOP_ID || '0';

  const {
    name,
    logoUrl,
    storeUrl,
    color,
    lightColor,
    error
  } = useShop(shopId);
  const background = {'--color': color} as React.CSSProperties;

  return (
  <div className="LoadingTriangleContainer">
    <div className="lds-roller" style={background}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    {withText && <h3>{withText}</h3>}
  </div>
)};
